import React from 'react';

const DishGallery = ({ dishes }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {dishes.map((dish) => (
        <div
          key={dish.id}
          className="dish-item overflow-hidden rounded-lg shadow-sm transition-transform hover:scale-105 cursor-pointer"
        >
          <div className="relative aspect-square">
            <img
              src={dish.image}
              alt={dish.name}
              className="w-full h-full object-cover"
            />
            {dish.name && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                {/* MODIFICATIONS ICI :
                   - text-xl : Texte plus grand (au lieu de text-sm)
                   - font-bold : Plus gras pour la lisibilité
                   - font-sans : Assure que c'est du Montserrat
                */}
                <p className="text-[#F9F6F0] text-1xl font-sans leading-tight">
                    {dish.name}
                </p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DishGallery;
